import logo from "../logo.svg";
import "../App.css";
import Test from "../components/test";
import { Button, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import download from "../assets/download.jpg";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import MyModal from "./modal";
import WelcomeSection from "./welcomeSection";
import Companies from "./companies";
import Showcase from "./showcase";
import Portfolio from "./porfolio/portfolio.js";
const Home = ()=>{
    return(
      <div className="App">
        <Portfolio></Portfolio>
     
        {/* <WelcomeSection></WelcomeSection> */}
      
         {/* <Companies></Companies> */}
      
       {/* <Showcase></Showcase> */}
      

          {/* <header>
          <img src={logo} className="App-logo" alt="logo" />
          <p>
            Edit <code>src/App.js</code> and save to reload.
          </p>
          <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn React
          </a>
          <MyModal></MyModal>
          <Test></Test>
          <Button className>button</Button>
          <Card style={{ width: "18rem" }}>
            <Card.Img variant="top" src={download} />
            <Card.Body>
              <Card.Title>Card Title</Card.Title>
              <Card.Text>
                Some quick example text to build on the card title and make up
                the bulk of the card's content.
              </Card.Text>
              <Button variant="primary">Go somewhere</Button>
            </Card.Body>
          </Card>
        </header> */}
      </div>
    );
}
export default Home;